var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-steps"},[_c('ul',{staticClass:"progress-steps-list"},_vm._l((_vm.steps.filter(function (s) { return s.visible !== true; })),function(step,index){return _c('li',{key:index,staticClass:"progress-step",class:[
        {
          'progress-step--active': _vm.progressStep === step.order,
          'progress-step--completed': _vm.progressStep > step.order,
        },
        { 'progress-step--completed': step.checkingVerification } ]},[_c('span',{staticClass:"progress-step-circle"}),_vm._v(" "+_vm._s(step.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }